import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import Select from "react-select";
import ModalComp from "../Modal";
import PropTypes from "prop-types";
import { GetCookie, toast } from "../../Libraries/Media";
import { useGetAllScreensforTTSMutation } from "../../Redux/service/AllEmpData";

const AnnouncmentTxtToSpeech = ({ isAnnouncment, closeAnnouncmentModal }) => {
  const [AllScreens, setAllScreens] = useState([]);
  const [selectedscreens, setselectedscreens] = useState([]);
  const [command, setcommand] = useState();
  const [getAllScreensfortts] = useGetAllScreensforTTSMutation();

  const txtScreenObjects = selectedscreens?.map((option) => {
    return {
      txt_screen_id: option.value,
    };
  });

  async function sendCommand() {
    const payload = new FormData();
    payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
    payload.append("security_token", GetCookie("es_token"));
    payload.append("screens", JSON.stringify(txtScreenObjects));
    payload.append("txt_voice_commands", command);
  
    // payload.append(
    //   "screens",
    //   JSON.stringify([
    //     { txt_screen_id: "2532" },
    //     { txt_screen_id: "2533" }
    //   ])
    // );
  
    let url = "https://bbapi.nayatel.com/api/api/web/screen/sendVoiceCommands.php";
    let options = {
      body: payload,
      method: "POST",
    };
    const response = await fetch(url, options);
    const data = await response.json();

    if(data.status === "true" && data.message === "Voice command has been sent"){
      toast.success(data.message);
    }
    else{
      toast.error(data.message)
    }
    console.log(data);
  }

  const AnnounBody = () => {
    return (
      <>
        <Box className="feedbackheader">
          <Box display={"flex"} justifyContent={"space-between"}>
            <span style={{ color: "#1776EE", fontWeight: "bold" }}>
              Text-to-Speech Announcment
            </span>
            <span style={{ cursor: "pointer" }} onClick={closeAnnouncmentModal}>
              <CancelIcon />
            </span>
          </Box>
        </Box>

        <Box className="feedbackinputfieldbox" mt={3}>
          <label
            style={{
              marginBottom: "10px",
            }}
          >
            Select Screens
          </label>
          <Select
            className="basic-single"
            classNamePrefix="select"
            isSearchable={true}
            name="color"
            isMulti
            onChange={setselectedscreens}
            options={AllScreens}
          />
          <label style={{ marginTop: "16px", marginBottom: "10px" }}>
            Type your command
          </label>
          <textarea
            onChange={(e) => setcommand(e.target.value)}
            rows={5}
            placeholder="Type here..."
            className="feedbacktextarea"
            style={{ height: "auto" }}
          />
        </Box>
        <Box
          className="feedbacksubmitbutton"
          display={"flex"}
          justifyContent={"end"}
          mt={2}
        >
          <Button variant="contained" onClick={sendCommand} className="capitalized fs-14 fw-bold">
            Play
          </Button>
        </Box>
      </>
    );
  };

  useEffect(() => {
    const getAllScreens = async () => {
      const verifyscreenotp = new FormData();
      verifyscreenotp.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      verifyscreenotp.append("security_token", await GetCookie("es_token"));

      try {
        const returned = await getAllScreensfortts(verifyscreenotp).unwrap();
        if (
          returned.status === "true" &&
          returned.connection === "true" &&
          returned.message === "Screens available"
        ) {
          setAllScreens(returned.data);
        }
        // else {
        //   toast.error(returned.message);
        // }
      } catch (error) {
        toast.error(error.status);
        console.log(error);
      }
    };

    getAllScreens();
  }, [getAllScreensfortts]);

  return (
    <div>
      <ModalComp open={isAnnouncment} onCloseModal={closeAnnouncmentModal}>
        {AnnounBody()}
      </ModalComp>
    </div>
  );
};

AnnouncmentTxtToSpeech.propTypes = {
  isAnnouncment: PropTypes.bool,
  closeAnnouncmentModal: PropTypes.func,
};

export default AnnouncmentTxtToSpeech;
